const DEFAULT_PIXEL_SIZE =
  typeof window === 'undefined' ? 16 : parseInt(window.getComputedStyle(document.documentElement).fontSize, 10) || 16

/**
 * Converts a given size in pixels to rem
 *
 * @param {number|string} size Size in pixels
 * @returns {string} Size in rem
 */
export const rem = (size) => {
  const pixels = parseInt(size, 10)
  return `${parseFloat((pixels / DEFAULT_PIXEL_SIZE).toPrecision(7))}rem`
}
